export default "__VITE_ASSET__B2TuJ_yb__"